import '../../monitoring/select_view.js.coffee'
Namespace 'Customer.Filters'

class Customer.Filters.SelectView extends App.SelectView
  className: 'customer-filters-select-view'

  initialize: ({options, valueProperty, descriptionProperty, selectedOptions, placeholder, disabledPlaceholder,
      editable, title}) ->
    @title = title || ''
    super({options, valueProperty, descriptionProperty, selectedOptions, placeholder, disabledPlaceholder, editable})

  render: =>
    super()
    @$el.prepend("<h2 class='title'>#{@title}</h2>")
    @$el.find('.tags').addClass('mini-scrollbar')
    @
